<template>
  <div class="container activityIndex scanContent">
    <div class="pageList">
      <div class="padding15 pageListItem">
        <div class="hasInfo" style="width: 100%">
          <div class="actPicture">
            <van-image fit="cover" :src="info.photoUrl" />
          </div>
          <div class="actText">
            <van-row type="flex" justify="space-between" class="colorBlack">
              <van-col
                span="24"
                class="van-ellipsis fz16 textBold marginBottom3"
                >{{ info.activityName }}</van-col
              >
            </van-row>
            <van-row
              type="flex"
              justify="space-between"
              class="marginTop3 colorGrey1"
            >
              <!-- <van-col span="24" class="van-ellipsis">开放时间：{{info.businessHours}}</van-col> -->
              <!-- 是否长期(1是 2否) -->
              <van-col
                span="24"
                class="van-ellipsis"
                v-if="info.isLongTerm == 2"
                >活动时间：{{ info.activityStartTime }} -
                {{ info.activityEndTime }}</van-col
              >
              <van-col
                span="24"
                class="van-ellipsis"
                v-if="info.isLongTerm == 1"
                >长期</van-col
              >
            </van-row>
            <van-row
              type="flex"
              justify="space-between"
              class="marginTop3 colorGrey1 address"
            >
              <van-col span="24" class="van-ellipsis2"
                >地址：{{ info.address }}</van-col
              >
            </van-row>
            <van-row
              type="flex"
              justify="space-between"
              class="marginTop30 points"
            >
              <van-col span="24" class="van-ellipsis">
                <i
                  class="iconfont icon-jifen marginRight5"
                  style="color: #ccc"
                />奖励积分: <span class="num">{{ info.signUpIntegral }}</span
                >分
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <van-divider />
      <div class="consumeList" v-if="info.isConsume == 1">
        <div
          v-for="item in info.consumeTypeList"
          :key="item.id"
          @click="handleSelect(item)"
        >
          <div class="consumeItem" :class="{ active: item.id === consumeId }">
            {{ item.typeName }}，{{ item.money }}元
          </div>
        </div>
      </div>
      <van-tabs v-model="tabActive" scrollspy v-if="info.isConsume == 2">
        <van-tab title="活动内容">
          <div class="ql-snow ql-editor">
            <div class="activity-main" v-html="info.content"></div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="scanBtn">
      <van-button
        type="primary"
        round
        block
        v-if="info.isConsume == 1"
        @click="handlePay"
        >确认支付</van-button
      >
      <van-button
        type="primary"
        round
        block
        v-if="info.isConsume == 2"
        @click="handleSign"
        >马上签到</van-button
      >
    </div>
    <div id="allmap" style="width: 100%; height: 0"></div>
  </div>
</template>

<script>
import { actDetail } from "@/api/activity";
import { actPay, userSignIn } from "@/api/data";
export default {
  data() {
    return {
      info: "",
      consumeId: "",
      consumeName: "",
      consumeMoney: "",
      tabActive: 0,
    };
  },
  created() {
    this.getActDetail();
  },

  methods: {
    handleSelect(item) {
      this.consumeId = item.id;
      this.consumeName = item.typeName;
      this.consumeMoney = item.money;
    },
    getActDetail() {
      actDetail({ id: parseInt(this.$route.query.id) }).then((res) => {
        if (res) {
          this.info = res.data;
        } else {
          this.$toast.fail("二维码有误，请重新扫码");
          this.$router.push({ path: "/" });
        }
      });
    },
    handlePay() {
      let _this = this;
      if (!this.consumeId) {
        this.$toast.fail("请选择套餐");
        return;
      }
      this.$dialog
        .confirm({
          title: "支付",
          message: "确定支付吗？",
        })
        .then(() => {
          actPay({
            activityId: this.$route.query.id,
            consumeId: _this.consumeId,
          }).then((res) => {
            console.log(res);
            if (res) {
              this.$router.push({
                path: "/paySuccess",
                query: {
                  isSuccess: 1,
                  consumeId: _this.consumeId,
                  consumeName: _this.consumeName,
                  consumeMoney: _this.consumeMoney,
                },
              });
            } else {
              this.$router.push({
                path: "/paySuccess",
                query: {
                  isSuccess: 2,
                  consumeId: _this.consumeId,
                  consumeName: _this.consumeName,
                  consumeMoney: _this.consumeMoney,
                },
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    handleSign() {
      let _this = this;
      var map = new BMap.Map("allmap");
      //Point类描述了一个地理坐标点，其中108.95表示经度，34.27表示纬度
      var point = new BMap.Point(108.95, 34.27);
      //启用滚轮放大缩小
      map.enableScrollWheelZoom();
      // 设置中心点坐标和地图级别
      map.centerAndZoom(point, 12);
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function (r) {
          console.log(r)
          console.log(this.getStatus());
          if (this.getStatus() == 0) {
            var mk = new BMap.Marker(r.point);
            map.addOverlay(mk); //标出所在地
            map.panTo(r.point); //地图中心移动
            console.log("您的位置：" + r.point.lng + "," + r.point.lat);
            userSignIn({
              activityId: _this.$route.query.id,
              userId: _this.$store.state.userInfo.id,
              dimension: r.point.lat,
              longitude: r.point.lng,
            }).then((res) => {
              if (res) {
                _this.$router.push({
                  path: "/signSuccess",
                  query: { integaral: res.data.integral },
                });
              }
            });
          } else {
            _this.$toast.fail("获取地理位置失败：" + this.getStatus());
          }
        },
        { enableHighAccuracy: true }
      );
    },
  },
};
</script>

<style lang='less'>
.scanContent {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-image: url("../../assets/images/indexTopBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // padding-top:60px;
  .ql-snow {
    max-height: calc(100vh - 340px);
    overflow-y: auto;
  }
  .pageList {
    background: #fff;
    padding: 10px;
    box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0.2);
    margin: 0 15px 70px;
    border-radius: 0.26667rem;
    .pageListItem {
      box-shadow: none;
      padding: 0;
      margin: 0;
    }
  }
  .consumeList {
    .consumeItem {
      display: inline-block;
      border-radius: 15px;
      margin: 5px 0;
      padding: 5px 10px;
      background: #f2f2f2;
      color: #282828;
    }
    .consumeItem.active {
      background: #d6253c;
      color: #fff;
    }
  }
  .van-tabs__nav--line {
    display: block;
    width: 1.94667rem;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 0.8rem;
  }
  .van-tabs__line {
    width: 0.42667rem;
    border-radius: 0.53333rem;
  }
  .activity-main img {
    width: 100%;
    overflow: hidden;
    border-radius: 0.16rem;
    margin: 0.21333rem 0;
  }
}
.scanBtn {
  position: fixed;
  bottom: 0;
  left: 0px;
  right: 0;
  padding: 10px;
  background: #fff;
}
</style>